<template>
  <div class="headerBox">
    <div class="whiteCircle"></div>
    <div class="yellowCircle circle-gradient" id="yellowCircleCombo"></div>
    <div class="comboBlock">
      <div class="comboName">
        {{
          activeCombo.components[0].selected
            ? getTranslation(
                $store,
                "Product",
                "display_name",
                activeCombo.components[0].selected.id,
                activeCombo.components[0].selected.name
              )
            : ""
        }}
      </div>
      <div class="requestImgBlock" id="requestImgBlock">
        <img class="requestImg" :src="menuImage" />
      </div>
    </div>
  </div>
</template>
<script>
import { getTranslation } from "@/utils/helpers";

export default {
  props: ["activeCombo"],
  computed: {
    menuImage() {
      let menu_image = require("@/assets/img/burger_menu.png");
      if (this.activeCombo.components[0].selected) {
        const mainItem = this.activeCombo.components[0].selected;
        this.activeCombo.product_ids.forEach(elem => {
          if (elem.id === mainItem.id) {
            if (elem.menu_preview) {
              menu_image = elem.menu_preview;
            }
          }
        });
      }
      return menu_image;
    }
  },
  methods: {
    getTranslation
  }
};
</script>
<style lang="scss" scoped>
.headerBox {
  height: 450px;
}
.whiteCircle {
  border-radius: 50%;
  background: var(--component_combo_headerCombo_whiteCircle_background);
  position: absolute;
  top: -552px;
  left: -584px;
  width: 1166px;
  height: 1166px;
  padding-top: 350px;
  padding-left: 650px;
  z-index: 2;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.yellowCircle {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  top: -466px;
  left: -59px;
  width: 1199px;
  height: 1153px;
  z-index: 3;
  /* height: 3000px;
  width: 3000px;
  left: -500px;
  z-index: 100; */
  position: absolute;
  border-radius: 50%;
}
.comboBlock {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  top: -466px;
  left: -59px;
  width: 1199px;
  height: 1153px;
  position: absolute;
  border-radius: 50%;
  z-index: 3;
}
.comboName {
  color: var(--component_combo_headerCombo_comboName_color);
  text-transform: var(--component_combo_headerCombo_comboName_text-transform);
  font-size: var(--component_combo_headerCombo_comboName_font-size);
  font-family: var(--component_combo_headerCombo_comboName_font-family);
  position: absolute;
  top: 530px;
}
.requestImgBlock {
  position: absolute;
  top: 670px;
  opacity: 0;
}
.circle-gradient {
  background: var(--circle-gradient);
}
</style>
